import React from 'react';
import { Button, ButtonColor } from 'ui-builder';

interface ErrorStatusProps {
  message: string;
  onRetry: () => void;
}

export default function ErrorStatus({ message, onRetry }: ErrorStatusProps) {
  return (
    <div>
      <i
        className="fa fa-exclamation-circle"
        style={{ fontSize: '2rem', marginBottom: '1rem', color: '#dc3545' }}
      />
      <h2 style={{ marginBottom: '1rem', color: '#dc3545' }}>Login failed</h2>
      <p style={{ color: '#666', marginBottom: '2rem' }}>{message}</p>
      <Button
        text="Return to Login"
        color={ButtonColor.GREEN}
        onClick={onRetry}
      />
    </div>
  );
}